import { Theme } from "../../../../../components/constants";

export default {
    bodyText: {
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: "32px",
        color: "#262626",
        textAlign: "center",
    },
    messageBox: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        padding: "30px"
    },
    buttonsContainer: {
        display: "flex",
        columnGap: "10px",
        marginTop: "40px"
    },
    button: {
        width: "100px",
    },
    childrenStyles: {
        overflow: "visible",
        padding: "0px 40px 25px 40px",
    },
    dropdownMenu: {
        width: "100%",
    },
    errorTxt: {
        color: Theme.ERROR_TEXT,
        margin: "12px 0px 0px"
    },
    noteTxt: {
        color: Theme.WARNING_TEXT,
        margin: "12px 0px 0px",
    },
    referenceNumbersContainer: {
        marginTop: "10px",
    }
}